import { HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Script } from "./types";

// Configuration
export const MIN_PAYMENT_AMOUNT: number = 0;
export const MAX_PAYMENT_AMOUNT: number = 75;
export const DEFAULT_GEOLOCATION_POSITION = { lat: 40.4166942, lng: -3.7038565 };
export const IVA: number = 1.21;
export const CHARGE_RETRY_LIMIT: number = 3;
export const STOP_RETRY_LIMIT: number = 2;
export const bundleID = 'es.wenea.app.client:id'

// User cannot stop charge in the first minute
export const CHARGE_STOP_TIMEOUT: number = 60000;

// Endpoints

const BASE_HOST_DES: string = `https://backend-des.wenea.site`
const BASE_HOST_PRE: string = `https://backend-pre.wenea.site`
const BASE_HOST_PRO: string = `https://backend-pro.wenea.site`

// New backend endpoints
const BASE_URI_DES: string = `https://backend-des.wenea.site/api`;
const BASE_URI_PRE: string = `https://backend-pre.wenea.site/api`;
const BASE_URI_PRO: string = `https://backend-pro.wenea.site/api`;
const BASE_URI_DEHESA: string = `https://backend-dehesa.wenea.site/api`;
const BASE_URI_BOX: string = `https://backend-sandbox.wenea.site/api`;
const BASE_URI_LOCAL: string = `http://localhost/api`;
const BASE_URI_DES_CLOUD: string = `https://backend-des.wenea.site/remote-status/`;
const BASE_URI_PRE_CLOUD: string = `https://backend-pre.wenea.site/remote-status/`;
const BASE_URI_PRO_CLOUD: string = `https://backend-pro.wenea.site/remote-status/`;

const IM_GATEWAY_DOMAIN_PRO: string = 'imspagofacil.es';
const IM_GATEWAY_DOMAIN_DES: string = 'test.imspagofacil.es';

// Endpoint configuration
const BASE_URI: string = BASE_URI_PRO;
const IM_GATEWAY_DOMAIN: string = IM_GATEWAY_DOMAIN_PRO;
export const WENEA_DONWLOAD_INVOICE: string = `${BASE_HOST_PRO}/web/invoices/`

// Revisar antes de subir
export const mapStyleIDDES: string = '868b05cc9fa56556';
export const mapStyleIDPRE: string = '998270950e4bb8fe';
export const mapStyleIDPRO: string = 'cad7f5e3a78bf3ca';

const WENEA_API_VERSION: string = "v7";
export const USER_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/user`;
const FINANCE_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/finance`;
const EVCHARGE_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/evcharge`;

export const FCM_DEVICES_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/devices/`

// Imgs configuration
export const WENEA_IMG_CLOUD: string = "http://backend.wenea.site/app/images/";

// HTML configuration
export const WENEA_HTML_CLOUD: string = "http://backend.wenea.site/app/html/";

// Masmovil configuration
export const NOGPS_GROUP_NAME = "NOGPS";
export const KEY_SAVE_VEHICLE = "vehiculo_preferente";

// User-related endpoints
export const WENEA_USER_AUTH: string = `${USER_ENDPOINT}/login/`;
export const WENEA_USER_REGISTER: string = `${USER_ENDPOINT}/register/`;
export const WENEA_USER_PASSWORD_CHANGE: string = `${USER_ENDPOINT}/password/change/`;
export const WENEA_USER_PASSWORD_RESET: string = `${USER_ENDPOINT}/password/reset/`;
export const WENEA_USER_INFO: string = `${USER_ENDPOINT}/info/`;
export const WENEA_USER_LOGIN: string = `${USER_ENDPOINT}/login/`;
export const WENEA_USER_LOGOUT: string = `${USER_ENDPOINT}/logout/`;
export const WENEA_USER_GROUPS: string = `${USER_ENDPOINT}/groups/`;
export const WENEA_USER_COUNTRIES: string = `${BASE_URI}/${WENEA_API_VERSION}/countries/`
export const WENEA_USER_DISCOUNT_APPLIED: string = `${EVCHARGE_ENDPOINT}/transactions/auth/info/`;
export const WENEA_USER_SOCIAL_LOGIN: string = `${BASE_URI}/social/login/?provider=google-openidconnect&access_token=`;
export const WENEA_USER_PROFILE: string = `${USER_ENDPOINT}/profile/`;
export const WENEA_USER_PROFILE_IMG: string = `${USER_ENDPOINT}/profile/image/`;
export const WENEA_USER_PAYMENTS: string = `${FINANCE_ENDPOINT}/payments/methods/`;
export const WENEA_USER_VEHICLES: string = `${USER_ENDPOINT}/vehicles/`;
export const WENEA_USER_VEHICLES_BRANDS: string = `${WENEA_USER_VEHICLES}brands/`;
export const WENEA_USER_VEHICLES_MODELS: string = `${WENEA_USER_VEHICLES}models/`;
export const WENEA_USER_VEHICLES_PORTS: string = `${WENEA_USER_VEHICLES}ports/`;
export const WENEA_USER_WENS: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/user/wens/`;
export const WENEA_USER_WENS_HISTORY: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/user/wallets-history/`;
export const WENEA_USER_COUPONS: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/coupons`
export const WENEA_USER_REFERRAL: string = `${WENEA_USER_COUPONS}/referal/`
export const WENEA_USER_ACTIVE_SUBSCRIPTION: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/user/active-subscription/`;
export const WENEA_USER_SUBSCRIPTION_TYPE: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/subscription/types/`;
export const WENEA_USER_SUBSCRIPTIONS: string = `${BASE_URI}/${WENEA_API_VERSION}/sales/subscriptions/`;
export const WENEA_SUBSCRIPTION_INVOICE: string = `${BASE_URI}/${WENEA_API_VERSION}/finance/full-invoices/`;
export const FILTER_PREFS_ENDPOINT: string = `${USER_ENDPOINT}/preferences/filters/`

// Payment gateway endpoints
export const WENEA_USER_PAYMENT_TOKEN: string = `${FINANCE_ENDPOINT}/payments/token/`;
export const WENEA_USER_CARD_REGISTER: string = `${FINANCE_ENDPOINT}/payments/register/`;
export const WENEA_USER_GET_INVOICE: string = `${FINANCE_ENDPOINT}/payments/`;
export const WENEA_USER_GET_IMSURL: string = `${FINANCE_ENDPOINT}/payments/web-form-url/`;

// Station-related endpoints
export const RP_STATIONS_MARCADOR_DEV: string = `${EVCHARGE_ENDPOINT}/stations/`;
export const PLUG_STATUS_ENDPOINT: string = `${EVCHARGE_ENDPOINT}/stations/plugs/`;
export const ABRP_ROUTE_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/route-plans/`;
export const BOOKING_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/reservations`;

// Charge-related endpoints
export const CHARGE_PROCESS_PAGES = ["ChargePage", "ChargeSumPage", "StartChargePage"];
export const EVCHARGE_TRANSACTION_DEV: string = `${EVCHARGE_ENDPOINT}/transactions`;
export const WENEA_AUTH_CHARGE_DEV: string = `${EVCHARGE_TRANSACTION_DEV}/auth/`;
export const WENEA_RP_START_DEV: string = `${EVCHARGE_TRANSACTION_DEV}/start/`;
export const WENEA_RP_STOP_DEV: string = `${EVCHARGE_TRANSACTION_DEV}/stop/`;
export const WENEA_METER_VALUES_DEV: string = `${EVCHARGE_TRANSACTION_DEV}/getmeter/`;
export const WENEA_RP_USER_HISTORY: string = `${EVCHARGE_ENDPOINT}/transactions/user/`;
export const WENEA_CHART_HISTORY: string = `${EVCHARGE_ENDPOINT}/transactions`;
export const WENEA_TRANSACTION_ACTIVE: string = `${EVCHARGE_ENDPOINT}/transaction/active/`;

// Kiosk endpoints
export const WENEA_KIOSK_INIT: string = `${EVCHARGE_ENDPOINT}/kiosk-transactions/init/`
export const WENEA_KIOSK_EXIT: string = `${EVCHARGE_ENDPOINT}/kiosk-transactions/exit/`
export const WENEA_KIOSK_TIMEOUT_1 = 30000;
export const WENEA_KIOSK_TIMEOUT_2 = 30000;

// Version check
export const WENEA_VERSION: string = environment.version;
export const WENEA_VERSION_ENDPOINT: string = `${BASE_URI}/${WENEA_API_VERSION}/admin/upgrade/`;
export const WENEA_ANDROID_STORE_LINK: string = "market://details?id=es.wenea.app.client";
export const WENEA_IPHONE_STORE_LINK: string = "https://apps.apple.com/es/app/wenea/id1475622185?l=en"
export const WENEA_CLOUD_URL: string = `${BASE_URI_PRO_CLOUD}`
export const GOOGLE_MAPS_READY: string = "https://maps.googleapis.com/maps/api/mapsjs/gen_204?csp_test=true";
export const CLOUD_READY: string = `https://backend-des.wenea.site/api/readiness`;
export const RPOINT_NAME_DEV: string = "ACANTO_DEMO_1";
export const CONNECTOR_DEV: string = "1";
// MS_REFRESH = time to ask for meter values (in milliseconds)
export const MS_REFRESH_METER_VALUES: string = "25000";
export const WENEA_APP_CONFIG: string = `${BASE_URI}/${WENEA_API_VERSION}/external/app/config/`;

// TODO: CHANGE IF POSSIBLE TO SSL IN PRODUCTION

// API PAY
export const IM_GATEWAY_PAYMENT_URI: string = `https://${IM_GATEWAY_DOMAIN}/client`;

// API ESTACIONES
export const GOOGLE_MAPS_BASE_URI: string = 'https://maps.googleapis.com/maps';

// Defaults
export const BASE_REST_HEADER = new HttpHeaders({
  'Content-Type': 'application/json',
  "X-App-Version": WENEA_VERSION,
  "X-App-Name": "KIOSK"
});

// Regex sentences
export const USER_DOCUMENT_NIF_REGEX: string = '^(?:[0-9]{6,8}[TRWAGMYFPDXBNJZSQVHLCKE])$';
export const USER_DOCUMENT_NIE_REGEX: string = '^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$';
export const USER_DOCUMENT_CIF_REGEX: string = '^(?:[ABCDEGHLM][0-9]{8}|[FJKNPQRSUVW][0-9]{7}[A-Z])$';

export const PASSWORD_REGEX: string = '^[a-zñA-Z0-9@\$€!%\*#?&\-_\+ç]+';
export const PASSWORD_REGEX_STRONG: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})';
export const PASSWORD_REGEX_MEDIUM: string = '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})';

export const USER_NAME_REGEX: string = '^([a-zA-ZÀ-ÖØ-öø-ÿ\\s]{1,30})$';
export const USER_SURNAME_REGEX: string = '^([a-zA-ZÀ-ÖØ-öø-ÿ\\s]{1,30})$';
export const USER_MAIL_REGEX: string = '^([a-z0-9.]+@[a-z0-9.]+.[a-z]{2,9})$';
export const USER_PHONE_REGEX: string = '^([0-9]|\\(|\\)|\\+|\\-|\\ ){1,20}$';
export const USER_DOCUMENT_REGEX: string = '^(?:[0-9]{6,8}[TRWAGMYFPDXBNJZSQVHLCKE]|[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]|(?:[ABCDEGHLM][0-9]{8}|[FJKNPQRSUVW][0-9]{7}[A-Z]))$';
export const USER_GENERIC_DOCUMENT_REGEX: string = '^([0-9a-zA-Z]{0,50})$';
export const POSTAL_CODE_REGEX: string = '^([a-zA-Z0-9\\ \\-]){5,15}$';


export const mapStyle = [
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#686868"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f2f2f2"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "saturation": -100
      },
      {
        "lightness": 45
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "lightness": "-22"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "saturation": "11"
      },
      {
        "lightness": "-51"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text",
    "stylers": [
      {
        "saturation": "3"
      },
      {
        "lightness": "-56"
      },
      {
        "weight": "2.20"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "lightness": "-52"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "weight": "6.13"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.icon",
    "stylers": [
      {
        "lightness": "-10"
      },
      {
        "gamma": "0.94"
      },
      {
        "weight": "1.24"
      },
      {
        "saturation": "-100"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "lightness": "-16"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "saturation": "-41"
      },
      {
        "lightness": "-41"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "weight": "5.46"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "weight": "0.72"
      },
      {
        "lightness": "-16"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "lightness": "-37"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#0065c1"
      },
      {
        "visibility": "on"
      },
      {
        "saturation": "-58"
      },
      {
        "lightness": "72"
      }
    ]
  }
]

